var PlanFactory = function ($resource, $window) {
    var planApi = "/participant-web-services/rest/partialauth/profile/plans";

    return $resource(
        __baseApiUrl__ + planApi,
        {},
        {
            get: {
                method: "GET",
                isArray: false
            }
        }
    );
};

PlanFactory.$inject = ["$resource", "$window"];
export default PlanFactory;
